export default __webpack_public_path__ + "static/media/ic_optimism.62e4c6c1.svg";